module.exports = __webpack_public_path__ + "static/btcbch.c138cd3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/btcbch.png
// module id = 1047
// module chunks = 69062039818352